"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldEditorForm = void 0;
const input_1 = require("../../../components/input/input");
const i18n_1 = require("../../../i18n");
const mithril_1 = require("../../../mithril");
const services_1 = require("../../../services");
const store_1 = require("../../../store");
const user_card_1 = require("../../user.assign.modal/user.card");
const form_palette_1 = require("../form.palette");
const form_field_editor_1 = require("./form.field.editor");
const form_field_tree_view_1 = require("./form.field.tree.view");
const form_info_panel_style_1 = require("./form.info.panel.style");
const USER_CARD_CTX = { readonly: true };
class FormFieldEditorForm extends form_field_editor_1.FormFieldEditor {
    getTitleState() {
        const displayState = super.getTitleState();
        // Sync with form's current value only when not focused (handles external changes like clearAllFields)
        if (!displayState.focused && displayState.value !== this.field.displayName) {
            displayState.setValue(this.field.displayName);
        }
        return displayState;
    }
    getDescriptionState() {
        let displayState = this.state.get('description');
        if (displayState == null) {
            displayState = this.state.child(i18n_1.T.FORM_FIELD_DESCRIPTION, 'description');
            displayState.isLabelShown = true;
            displayState.isRequired = true;
            displayState.onValue((val) => this.field.Mutator.description(val !== null && val !== void 0 ? val : ''));
        }
        // Sync with form's current value only when not focused (handles external changes like clearAllFields)
        if (!displayState.focused && displayState.value !== this.field.description) {
            displayState.setValue(this.field.description);
        }
        displayState.readOnly = this.field.isLocked || !this.designer.isEditing;
        return displayState;
    }
    viewTree() {
        return form_field_tree_view_1.FormFieldTreeView.viewForm(this);
    }
    viewInfo() {
        return (0, mithril_1.m)('div', { className: form_info_panel_style_1.CSS.container }, [
            input_1.Input.view(this.getTitleState()),
            input_1.Input.view(this.getDescriptionState()),
            (0, mithril_1.m)('div', { className: form_info_panel_style_1.CSS.section.container }, [
                this.field.createdAt != null
                    ? this.viewOption(i18n_1.T.FORM_CREATED_AT, services_1.Services.DateTime.formatDateTime(this.field.createdAt))
                    : null,
                this.field.updatedAt != null
                    ? this.viewOption(i18n_1.T.COLLECTION_UPDATED_AT, services_1.Services.DateTime.formatDateTime(this.field.updatedAt))
                    : null,
                this.viewPLASupport(),
                this.viewUserInfo(),
            ]),
            form_palette_1.FormDesignerPalette.view((type) => this.designer.createField(this.field, type), this.depth),
        ]);
    }
    viewUserInfo() {
        if (this.field.updatedBy == null) {
            return null;
        }
        const updatedBy = store_1.AppStore.UserProfile.get(this.field.updatedBy);
        if (updatedBy == null) {
            return null;
        }
        return this.viewOption(i18n_1.T.COLLECTION_UPDATED_BY, user_card_1.UserCard.viewChip(updatedBy, USER_CARD_CTX));
    }
    get isCloneable() {
        return false;
    }
    viewPLASupport() {
        const options = this.field.metadata && this.field.metadata.options;
        if (options == null) {
            return null;
        }
        if (options.spidacalc != null) {
            return this.viewOption(i18n_1.T.FORM_PLA_SUPPORT, (0, i18n_1.Translate)(i18n_1.T.PLA_SPIDACALC));
        }
        if (options.ocalc != null) {
            return this.viewOption(i18n_1.T.FORM_PLA_SUPPORT, (0, i18n_1.Translate)(i18n_1.T.PLA_OCALC));
        }
        if (options.dds != null) {
            return this.viewOption(i18n_1.T.FORM_PLA_SUPPORT, (0, i18n_1.Translate)(i18n_1.T.PLA_DDS));
        }
        if (options.poleforeman != null) {
            return this.viewOption(i18n_1.T.FORM_PLA_SUPPORT, (0, i18n_1.Translate)(i18n_1.T.PLA_POLEFOREMAN));
        }
        if (options.ikePoleForeman != null) {
            return this.viewOption(i18n_1.T.FORM_PLA_SUPPORT, (0, i18n_1.Translate)(i18n_1.T.PLA_IKE_POLEFOREMAN));
        }
        return null;
    }
}
exports.FormFieldEditorForm = FormFieldEditorForm;
//# sourceMappingURL=form.field.editor.form.js.map